// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { TransportControlsGetString, TransportControlsGetStringAsync } from './types.generated'

const transportControlsLocales = ['en-US'] as const
const transportControlsBundle = i18nBundle('transport/transportControls', transportControlsLocales)

export const getString: TransportControlsGetString = transportControlsBundle.getString
export const getStringAsync: TransportControlsGetStringAsync =
    transportControlsBundle.getStringAsync
